import { TbAlertCircle } from "react-icons/tb";
import { PiCellSignalFullFill, PiCellSignalLowFill, PiCellSignalMediumFill, PiCellSignalNoneFill } from "react-icons/pi";

/**
 * Centralized priority configuration
 * Used across all components for consistent priority display
 */
export const PRIORITY_MAP = {
    no_priority: { 
        name: 'No Priority', 
        icon: PiCellSignalNoneFill, 
        color: 'text-neutral-500' 
    },
    low: { 
        name: 'Low', 
        icon: PiCellSignalLowFill, 
        color: 'text-violet-500' 
    },
    medium: { 
        name: 'Medium', 
        icon: PiCellSignalMediumFill, 
        color: 'text-orange-500' 
    },
    high: { 
        name: 'High', 
        icon: PiCellSignalFullFill, 
        color: 'text-red-500' 
    },
    urgent: { 
        name: 'Urgent', 
        icon: TbAlertCircle, 
        color: 'text-red-500' 
    }
};

/**
 * Get priority configuration by value
 * @param {string} priorityValue - The priority value
 * @returns {Object} Priority configuration object
 */
export const getPriorityConfig = (priorityValue) => {
    return PRIORITY_MAP[priorityValue] || PRIORITY_MAP.no_priority;
};

/**
 * Get all priority values as an array
 * @returns {Array} Array of priority values
 */
export const getPriorityValues = () => {
    return Object.keys(PRIORITY_MAP);
};

/**
 * Get priority configuration for API format (with icon names as strings)
 * Used for components that expect string icon names instead of components
 * @returns {Object} Priority config with string icon names
 */
export const getPriorityConfigForAPI = () => {
    const iconMapping = {
        'signal-none': PiCellSignalNoneFill,
        'signal-low': PiCellSignalLowFill,
        'signal-medium': PiCellSignalMediumFill,
        'signal-full': PiCellSignalFullFill,
        'alert-circle': TbAlertCircle,
    };
    
    return {
        no_priority: { name: 'No Priority', icon: 'signal-none', color: 'text-neutral-500' },
        low: { name: 'Low', icon: 'signal-low', color: 'text-violet-500' },
        medium: { name: 'Medium', icon: 'signal-medium', color: 'text-orange-500' },
        high: { name: 'High', icon: 'signal-full', color: 'text-red-500' },
        urgent: { name: 'Urgent', icon: 'alert-circle', color: 'text-red-500' }
    };
};
